export const FETCH_JOB_PROFILES = 'FETCH_JOB_PROFILES';
export const FETCHING_JOB_PROFILES = 'FETCHING_JOB_PROFILES';
export const FETCH_JOB_PROFILES_SUCCESS = 'FETCH_JOB_PROFILES_SUCCESS';
export const FETCH_JOB_PROFILES_FAILED = 'FETCH_JOB_PROFILES_FAILED';

export const FETCH_JOB_PROFILE = 'FETCH_JOB_PROFILE';
export const FETCHING_JOB_PROFILE = 'FETCHING_JOB_PROFILE';
export const FETCH_JOB_PROFILE_SUCCESS = 'FETCH_JOB_PROFILE_SUCCESS';
export const FETCH_JOB_PROFILE_FAILED = 'FETCH_JOB_PROFILE_FAILED';

export const SET_JOB_PROFILE = 'SET_JOB_PROFILE';

export function fetchJobProfiles() {
  return {
    type: FETCH_JOB_PROFILES,
  };
}

export function fetchingJobProfiles() {
  return {
    type: FETCHING_JOB_PROFILES,
  };
}

export function fetchJobProfilesSuccess(jobProfiles) {
  return {
    type: FETCH_JOB_PROFILES_SUCCESS,
    jobProfiles,
  };
}

export function fetchJobProfilesFailed(err) {
  return {
    type: FETCH_JOB_PROFILES_FAILED,
    message: err.message,
  };
}

export function fetchJobProfile(jobProfileId) {
  return {
    type: FETCH_JOB_PROFILE,
    jobProfileId,
  };
}

export function fetchingJobProfile(jobProfileId) {
  return {
    type: FETCHING_JOB_PROFILE,
    jobProfileId,
  };
}

export function fetchJobProfileSuccess(jobProfile) {
  return {
    type: FETCH_JOB_PROFILE_SUCCESS,
    jobProfile,
  };
}

export function fetchJobProfileFailed(jobProfileId,err) {
  return {
    type: FETCH_JOB_PROFILE_FAILED,
    jobProfileId,
    message: err.message,
  };
}

export function setJobProfile(jobProfile) {
  console.log('jobProfile',jobProfile);
  return {
    type: SET_JOB_PROFILE,
    jobProfile,
  };
}



// WEBPACK FOOTER //
// ./src/actions/jobprofiles.js